.tool-action {
  min-width: fit-content;
}
